import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import Select from 'react-select';

import BillOfQuantitiesContractorPacksTable from './BillOfQuantitiesContractorPacksTable';
import BillOfQuantitiesExpensesByVenueTable from './BillOfQuantitiesExpensesByVenueTable';
import BillOfQuantitiesSimplePacksTable from './BillOfQuantitiesSimplePacksTable';

import Button from 'CommonComponents/Button';

export default function BillOfQuantities() {
    const selectAllDepartmentsOptions = [
        { value: 'all_departments', label: $t('All Departments') },
        { value: 'custom_departments', label: $t('Custom Departments') },
    ];

    const [departments, setDepartments] = useState([]);

    const [selectAllDepartments, setSelectAllDepartments] = useState({
        value: 'all_departments',
        label: $t('All Departments'),
    });
    const [includeDepartments, setIncludeDepartments] = useState([]);
    const [includePackContractor, setIncludePackContractor] = useState(1);
    const [includePackSimple, setIncludePackSimple] = useState(1);
    const [includeExpenseByVenue, setIncludeExpenseByVenue] = useState(1);

    const [previewData, setPreviewData] = useState({});

    useEffect(() => {
        setTimeout(() => {
            axios
                .post(window.previewUrl, preparePreviewData())
                .then((response) => {
                    const { data } = response.data;
                    setPreviewData(data);
                })
                .catch((e) => {
                    console.log(e);
                });
        }, 500);
    }, [selectAllDepartments, includeDepartments, includePackContractor, includePackSimple, includeExpenseByVenue]);

    const preparePreviewData = () => {
        return {
            select_all_departments: selectAllDepartments.value,
            include_departments: includeDepartments,
            include_pack_contractor: includePackContractor,
            include_pack_simple: includePackSimple,
            include_expense_by_venue: includeExpenseByVenue,
        };
    };

    useEffect(() => {
        fetchConfigs();
    }, []);

    const fetchConfigs = () => {
        axios
            .get(window.departmentsUrl)
            .then((res) => {
                const { departments } = res.data;
                setDepartments(departments);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const changeIncludeDepartments = (e, key) => {
        const inc = { ...includeDepartments };
        inc[key] = inc[key] ? 0 : 1;
        setIncludeDepartments(inc);
    };

    const changeIncludePackContractor = (e) => {
        setIncludePackContractor(includePackContractor > 0 ? 0 : 1);
    };

    const changeIncludePackSimple = (e) => {
        setIncludePackSimple(includePackSimple > 0 ? 0 : 1);
    };

    const changeIncludeExpenseByVenue = (e) => {
        setIncludeExpenseByVenue(includeExpenseByVenue > 0 ? 0 : 1);
    };

    function onChangeSelectAllDepartments(option) {
        setSelectAllDepartments(option);
    }

    return (
        <>
            <div className="card bg-white border-0 rounded-15px shadow p-2">
                <div className="card-body">
                    <form method="POST" action={window.generateUrl}>
                        <input type="hidden" name="_token" value={window.csrfVal} />
                        <div className="row p-2">
                            <div className="col">
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor="select_departments">{$t('Departments')}</label>
                                        <Select
                                            name="select_all_departments"
                                            options={selectAllDepartmentsOptions}
                                            onChange={onChangeSelectAllDepartments}
                                            defaultValue={{
                                                value: 'all_departments',
                                                label: $t('All Departments'),
                                            }}
                                            value={selectAllDepartments}
                                        />
                                    </div>
                                </div>
                                {selectAllDepartments.value == 'custom_departments' && (
                                    <div className="row mt-3">
                                        <div className="col-12 pb-3">
                                            <h5 className="text-blue font-weight-600 mt-1">{$t('Departments')}</h5>
                                        </div>
                                        {departments.map((department) => (
                                            <div className="col-2" key={`department_${department.id}`}>
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        name={`include_departments[${department.id}]`}
                                                        className="include-column custom-control-input"
                                                        type="checkbox"
                                                        id={`include_departments[${department.id}]`}
                                                        defaultChecked={!!includeDepartments[department.id]}
                                                        value={includeDepartments[department.id]}
                                                        onChange={(e) => changeIncludeDepartments(e, department.id)}
                                                    />
                                                    <label className="custom-control-label" htmlFor={`include_departments[${department.id}]`}>
                                                        {department.name}
                                                    </label>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                <div className="row mt-3">
                                    <div className="col-12 pb-3">
                                        <h5 className="text-blue font-weight-600 mt-1">Expenses</h5>
                                    </div>
                                    <div className="col-2">
                                        <div className="custom-control custom-switch">
                                            <input
                                                name="include_pack_contractor"
                                                className="include-column custom-control-input"
                                                type="checkbox"
                                                id="include_pack_contractor"
                                                defaultChecked={!!includePackContractor}
                                                value={includePackContractor}
                                                onChange={changeIncludePackContractor}
                                            />
                                            <label className="custom-control-label" htmlFor="include_pack_contractor">
                                                {$t('Contractor Cost Packs')}
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="custom-control custom-switch">
                                            <input
                                                name="include_pack_simple"
                                                className="include-column custom-control-input"
                                                type="checkbox"
                                                id="include_pack_simple"
                                                defaultChecked={!!includePackSimple}
                                                value={includePackSimple}
                                                onChange={changeIncludePackSimple}
                                            />
                                            <label className="custom-control-label" htmlFor="include_pack_simple">
                                                {$t('Simple Cost Packs')}
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="custom-control custom-switch">
                                            <input
                                                name="include_expense_by_venue"
                                                className="include-column custom-control-input"
                                                type="checkbox"
                                                id="include_expense_by_venue"
                                                defaultChecked={!!includeExpenseByVenue}
                                                value={includeExpenseByVenue}
                                                onChange={changeIncludeExpenseByVenue}
                                            />
                                            <label className="custom-control-label" htmlFor="include_expense_by_venue">
                                                {$t('Expenses by venue')}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col">
                                <div className="float-right">
                                    <Button type={'submit'} variant="primary">
                                        {$t('Generate Report')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div className="row mt-3 no-gutters mx-n2" id="workforce-organigram-box">
                <div className="col px-2">
                    <div className="card border-0 py-2 bg-transparent">
                        <div className="card-body">
                            <nav className="mb-4">
                                <div className="row">
                                    <div className="col-6">
                                        <ul className="nav nav-tabs border-0 font-weight-600 nav-tabs-style-1" id="nav-tab" role="tablist">
                                            {previewData.contractor_packs && (
                                                <li className="nav-item" role="presentation">
                                                    <a
                                                        className="nav-item nav-link text-blue border-0 bg-transparent mr-3 px-2"
                                                        id="nav-contractor-packs-tab"
                                                        data-toggle="tab"
                                                        href="#nav-contractor-packs"
                                                        role="tab"
                                                        aria-controls="nav-contractor-packs"
                                                        aria-selected="true"
                                                    >
                                                        {$t('Contractor Packs')}
                                                    </a>
                                                </li>
                                            )}
                                            {previewData.simple_packs && (
                                                <li className="nav-item" role="presentation">
                                                    <a
                                                        className="nav-item nav-link text-blue border-0 bg-transparent mr-3 px-2"
                                                        id="nav-simple-packs-tab"
                                                        data-toggle="tab"
                                                        href="#nav-simple-packs"
                                                        role="tab"
                                                        aria-controls="nav-simple-packs"
                                                        aria-selected="true"
                                                    >
                                                        {$t('Simple Packs')}
                                                    </a>
                                                </li>
                                            )}
                                            {previewData.expenses_by_venue && (
                                                <li className="nav-item" role="presentation">
                                                    <a
                                                        className="nav-item nav-link text-blue border-0 bg-transparent mr-3 px-2"
                                                        id="nav-expenses-by-venue-tab"
                                                        data-toggle="tab"
                                                        href="#nav-expenses-by-venue"
                                                        role="tab"
                                                        aria-controls="nav-expenses-by-venue"
                                                        aria-selected="true"
                                                    >
                                                        {$t('Expenses by venue')}
                                                    </a>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </nav>
                            <div className="tab-content" id="nav-tabContent">
                                <div
                                    className="tab-pane fade p-0 show p-0 border-0"
                                    id="nav-contractor-packs"
                                    role="tabpanel"
                                    aria-labelledby="nav-contractor-packs"
                                >
                                    {previewData.contractor_packs && (
                                        <div className="row mt-4">
                                            <div className="col">
                                                {Object.keys(previewData.contractor_packs).length > 0 ? (
                                                    <BillOfQuantitiesContractorPacksTable data={previewData['contractor_packs']} />
                                                ) : (
                                                    <p>{$t('There are no Contractor Packs in the selected departments')}</p>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="tab-pane fade p-0 show p-0 border-0" id="nav-simple-packs" role="tabpanel" aria-labelledby="nav-simple-packs">
                                    {previewData.simple_packs && (
                                        <div className="row mt-4">
                                            <div className="col">
                                                {Object.keys(previewData.simple_packs).length > 0 ? (
                                                    <BillOfQuantitiesSimplePacksTable data={previewData['simple_packs']} />
                                                ) : (
                                                    <p>{$t('There are no Simple Packs in the selected departments')}</p>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div
                                    className="tab-pane fade p-0 show p-0 border-0"
                                    id="nav-expenses-by-venue"
                                    role="tabpanel"
                                    aria-labelledby="nav-expenses-by-venue"
                                >
                                    {previewData.expenses_by_venue && (
                                        <div className="row mt-4">
                                            <div className="col">
                                                {Object.keys(previewData.expenses_by_venue).length > 0 ? (
                                                    <BillOfQuantitiesExpensesByVenueTable data={previewData['expenses_by_venue']} />
                                                ) : (
                                                    <p>{$t('There are no Expenses by venue in the selected departments')}</p>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

if (document.getElementById('billOfQuantitiesTable')) {
    var rootEl = document.getElementById('billOfQuantitiesTable'); // data attributes below help us
    ReactDOM.render(
        <App>
            <BillOfQuantities />
        </App>,
        rootEl,
    );
}
